﻿import { Color } from "@material-ui/lab";

export default class BannerViewModel {
    public id: number = 0;
    public message: string = '';
    public linkText: string = '';
    public link: string = '';
    public visible: boolean = false;
    public alertType: Color = 'info';
}